export const assertUnreachable = (x: never): never => {
  throw new Error(`${x} should not be reachable`);
};

export type GetElementType<T extends Array<any>> = T extends (infer U)[] ? U : never;
